import {
  types,
  IGetMediaTypesAction,
  IGetMediaTypesSuccessAction,
  IUpdateMediaTypesAction,
  IFailureAction,
} from '../types/mediaTypes'
import { IMediaType } from '../types/mediaType'

export const getMediaTypes = (): IGetMediaTypesAction => ({
  type: types.GET_MEDIA_TYPES__STARTED,
})

export const getMediaTypesSuccess = (
  list: IMediaType[]
): IGetMediaTypesSuccessAction => ({
  type: types.GET_MEDIA_TYPES__SUCCESS,
  list,
})

export const updateMediaTypes = (
  list: IMediaType[]
): IUpdateMediaTypesAction => ({
  type: types.UPDATE_MEDIA_TYPES,
  list,
})

export const getMediaTypesFailure = (message: string): IFailureAction => ({
  type: types.GET_MEDIA_TYPES__FAILURE,
  message,
})
